<template>
  <div class="searchform">
    <div class="card bg-white mb-3">
      <div class="card-body">
        <h4 class="card-title mb-0"><i class="fas fa-search fa-fw mr-2"></i>Search</h4>
        <div class="row no-gutters mt-4">
          <div class="col-md-8 pr-1">
            <div class="form-group">
              <input class="form-control" v-model="searchterm" placeholder="Search...">
            </div>
          </div>
          <div class="col-md-4">
            <input type="button" class="btn btn-primary btn-block" value="GO" @click.stop.prevent="submit()">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      searchterm: null
    }
  },
  methods: {
    submit(){
      this.$router.push("/search/" + this.searchterm);
    }
  }
}
</script>
